import { render, staticRenderFns } from "./IntegrationEdit.vue?vue&type=template&id=925b7c72"
import script from "./IntegrationEdit.vue?vue&type=script&lang=js"
export * from "./IntegrationEdit.vue?vue&type=script&lang=js"
import style0 from "./IntegrationEdit.vue?vue&type=style&index=0&id=925b7c72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports